"use client";

import { useTranslations } from "next-intl";
import { BrandStoryMotion } from "./BrandStoryMotion";

/** Editorial public brand story. It intentionally uses no unapproved event imagery. */
export function AboutPageView() {
  const t = useTranslations("about");
  const principles = t.raw("engineering.principles") as string[];

  return (
    <article className="gruv-about">
      <header className="gruv-about__hero">
        <p className="gruv-about__eyebrow">{t("eyebrow")}</p>
        <h1>{t("title")}</h1>
        <p className="gruv-about__intro">{t("intro")}</p>
        <div className="gruv-about__hero-media">
          <BrandStoryMotion variant="pulse" />
        </div>
      </header>

      <section
        className="gruv-about__section gruv-about__section--origin"
        aria-labelledby="about-origin"
      >
        <div>
          <h2 id="about-origin">{t("origin.title")}</h2>
          <p>{t("origin.body")}</p>
        </div>
      </section>

      <section
        className="gruv-about__section"
        aria-labelledby="about-experience"
      >
        <div className="gruv-about__section-heading">
          <h2 id="about-experience">{t("experience.title")}</h2>
        </div>
        <div className="gruv-about__experience-story">
          <p className="gruv-about__body">{t("experience.body")}</p>
          <div className="gruv-about__app-media">
            <BrandStoryMotion variant="bridge" />
          </div>
        </div>
        <div className="gruv-about__audiences">
          <section>
            <h3>{t("experience.attendees")}</h3>
            <p>{t("experience.attendeesBody")}</p>
          </section>
          <section>
            <h3>{t("experience.organizers")}</h3>
            <p>{t("experience.organizersBody")}</p>
          </section>
        </div>
      </section>

      <section
        className="gruv-about__engineering"
        aria-labelledby="about-engineering"
      >
        <div>
          <p className="gruv-about__eyebrow">{t("engineering.eyebrow")}</p>
          <h2 id="about-engineering">{t("engineering.title")}</h2>
        </div>
        <div>
          <p>{t("engineering.body")}</p>
          <p>{t("engineering.bodyEnd")}</p>
          <ul
            className="gruv-about__principles"
            aria-label={t("engineering.title")}
          >
            {principles.map((principle) => (
              <li key={principle}>{principle}</li>
            ))}
          </ul>
          <div className="gruv-about__manager-media">
            <BrandStoryMotion variant="system" />
          </div>
        </div>
      </section>

      <section
        className="gruv-about__section gruv-about__section--craft"
        aria-labelledby="about-craft"
      >
        <div>
          <h2 id="about-craft">{t("craft.title")}</h2>
          <p>{t("craft.body")}</p>
        </div>
      </section>

      <div className="gruv-about__scan-media">
        <BrandStoryMotion variant="craft" />
      </div>

      <aside className="gruv-about__founder" aria-labelledby="about-founder">
        <h2 id="about-founder">{t("founder.title")}</h2>
        <p>{t("founder.body")}</p>
      </aside>

      <footer className="gruv-about__closing">
        <p>{t("closingTechnology")}</p>
        <h2>{t("closingExperiences")}</h2>
      </footer>
    </article>
  );
}
